import React, { useMemo } from 'react';
import { type ISaleLabelProps, SaleLabel } from '@secretescapes/cauldron';
import { BadgeType, BadgeVariant } from '@secretescapes/falcon';
import { partition } from '@utils/lodash.utils';

interface IBadges {
  badges: ISaleLabelProps[];
}

export const Badges = ({ badges }: IBadges) => {
  const filteredBadges = useMemo(() => {
    const [promoBadges, infoBadges] = partition(badges, ['type', BadgeType.PROMOTIONAL]);
    return [...promoBadges, ...infoBadges];
  }, [badges]);

  if (!filteredBadges.length) {
    return null;
  }

  return (
    <>
      {filteredBadges.map((badge, i) => {
        const { backgroundColor, icon, saleLabelTranslations, fontColor, priority, type } = badge;

        return (
          <SaleLabel
            disableTouch={false}
            key={`${saleLabelTranslations?.translatedLabelValue}_${icon}_${i}`}
            backgroundColor={backgroundColor}
            icon={icon}
            saleLabelTranslations={saleLabelTranslations}
            saleLabelVariant={BadgeVariant.normal}
            fontColor={fontColor}
            priority={priority}
            type={type}
            emboldened={type === BadgeType.INFORMATIONAL}
          />
        );
      })}
    </>
  );
};
